import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import axios from 'axios';

const API = 'https://app.b3rastreamento.com.br/api';

const MODELOS_EQUIP = [
  { modelo: 'TK103', fabricante: 'Coban', protocolo: 'GT06' },
  { modelo: 'TK303', fabricante: 'Accurate', protocolo: 'GT06' },
  { modelo: 'TK311', fabricante: 'Accurate', protocolo: 'GT06' },
  { modelo: 'Goome EV02', fabricante: 'Goome', protocolo: 'EV02' },
  { modelo: 'Goome GM06N', fabricante: 'Goome', protocolo: 'GT06' },
  { modelo: 'J16', fabricante: 'Jointech', protocolo: 'JT808' },
  { modelo: 'MXT 140', fabricante: 'Maxtrack', protocolo: 'Maxtrack' },
  { modelo: 'MXT 145', fabricante: 'Maxtrack', protocolo: 'Maxtrack' },
  { modelo: 'MXT 150', fabricante: 'Maxtrack', protocolo: 'Maxtrack' },
  { modelo: 'OneBlock', fabricante: 'OneBlock', protocolo: 'OneTag' },
  { modelo: 'OneTag', fabricante: 'OneBlock', protocolo: 'OneTag' },
  { modelo: 'GV50', fabricante: 'Queclink', protocolo: 'GT06' },
  { modelo: 'GV300', fabricante: 'Queclink', protocolo: 'GT06' },
  { modelo: 'GV310', fabricante: 'Queclink', protocolo: 'GT06' },
  { modelo: 'GV500', fabricante: 'Queclink', protocolo: 'GT06' },
  { modelo: 'ST310U', fabricante: 'Suntech', protocolo: 'ST' },
  { modelo: 'ST340', fabricante: 'Suntech', protocolo: 'ST' },
  { modelo: 'ST600R', fabricante: 'Suntech', protocolo: 'ST' },
  { modelo: 'ST4315', fabricante: 'Suntech', protocolo: 'ST' },
  { modelo: 'ST8310U', fabricante: 'Suntech', protocolo: 'ST' },
  { modelo: 'ST8310UM', fabricante: 'Suntech', protocolo: 'ST' },
  { modelo: 'ST100', fabricante: 'Sunteck', protocolo: 'GT06' },
  { modelo: 'ST200', fabricante: 'Sunteck', protocolo: 'GT06' },
  { modelo: 'ST300', fabricante: 'Sunteck', protocolo: 'GT06' },
  { modelo: 'ST400', fabricante: 'Sunteck', protocolo: 'GT06' },
];

const OPERADORAS = [
  { nome: 'Claro M2M', apn: 'claro.com.br', usuario: 'claro', senha: 'claro' },
  { nome: 'Vivo M2M', apn: 'zap.vivo.com.br', usuario: 'vivo', senha: 'vivo' },
  { nome: 'TIM M2M', apn: 'tim.br', usuario: 'tim', senha: 'tim' },
  { nome: 'Simple ARQIA', apn: 'simple.br', usuario: 'arqia', senha: 'arqia' },
  { nome: 'Simplepm Algar', apn: 'simplepm.algar.br', usuario: 'algar', senha: 'algar' },
  { nome: 'Algar IoT', apn: 'algar.br', usuario: 'algar', senha: 'algar' },
];

const TIPOS_VEICULO = ['Veículo de Passeio', 'Moto', 'Caminhão', 'Van', 'Ônibus', 'Barco', 'Trator', 'Máquina', 'Ambulância', 'Cavalo Mecânico', 'Carreta', 'Bicicleta', 'Patinete'];
const ICONES_VEICULO = ['🚗', '🏍️', '🚛', '🚐', '🚌', '⛵', '🚜', '🚑', '🚒', '🚕', '🚚', '🚲', '🛴'];
const CORES_VEICULO = ['#1D9E75', '#2563EB', '#DC2626', '#D97706', '#7C3AED', '#DB2777', '#0891B2', '#111827'];

const ETAPAS_BASE = [
  { id: 1, label: 'Equipamento', icone: '📟' },
  { id: 2, label: 'Chip GPRS', icone: '📡' },
  { id: 3, label: 'Cliente', icone: '👥' },
  { id: 4, label: 'Veículo', icone: '🚗' },
  { id: 5, label: 'Login', icone: '🔑' },
  { id: 6, label: 'Contrato', icone: '📄' },
  { id: 7, label: 'Resumo', icone: '✅' },
];

function CadastroRapido() {
  const [sidebarAberta, setSidebarAberta] = useState(false);
  const [etapaAtual, setEtapaAtual] = useState(1);
  const [erro, setErro] = useState('');
  const [salvando, setSalvando] = useState(false);

  const [equipamentos, setEquipamentos] = useState([]);
  const [linhas, setLinhas] = useState([]);
  const [clientes, setClientes] = useState([]);

  const [equipPulado, setEquipPulado] = useState(false);
  const [equipModo, setEquipModo] = useState('novo');
  const [equipExistenteId, setEquipExistenteId] = useState('');
  const [equipForm, setEquipForm] = useState({ serial: '', modelo: '', fabricante: '', protocolo: '', firmware: 'Original', observacoes: '' });

  const [linhaPulada, setLinhaPulada] = useState(false);
  const [linhaModo, setLinhaModo] = useState('novo');
  const [linhaExistenteId, setLinhaExistenteId] = useState('');
  const [linhaForm, setLinhaForm] = useState({ simcard: '', numero: '', operadora: '', apn: '', apn_usuario: '', apn_senha: '' });

  const [clienteModo, setClienteModo] = useState('novo');
  const [clienteExistenteId, setClienteExistenteId] = useState('');
  const [clienteForm, setClienteForm] = useState({
    nome_fantasia: '', razao_social: '', documento: '', email: '', celular: '',
    endereco: '', numero: '', bairro: '', cidade: '', estado: '', cep: '', plano: 'com_bloqueio'
  });

  const [veiculoForm, setVeiculoForm] = useState({
    identificador: '', nome: '', modelo: '', tipo: 'Veículo de Passeio',
    icone: '🚗', cor: '#1D9E75', observacoes: ''
  });

  const [loginAtivo, setLoginAtivo] = useState(false);
  const [loginForm, setLoginForm] = useState({ nome: '', email: '', senha: '', confirmarSenha: '', fuso_horario: 'America/Sao_Paulo' });

  const [templates, setTemplates] = useState([]);
  const [contratoAtivo, setContratoAtivo] = useState(false);
  const [contratoForm, setContratoForm] = useState({
    template_id: '', valor_mensal: '', dia_vencimento: '10', prazo_meses: '12',
    data_inicio: new Date().toISOString().split('T')[0], valor_por_rastreador: '',
    renovacao_automatica: true, observacao: ''
  });
  const [contratoResultado, setContratoResultado] = useState(null);

  const [criado, setCriado] = useState({ equipamentoId: null, linhaId: null, clienteId: null, targetId: null, loginId: null, contratoEnviado: false });
  const [resultado, setResultado] = useState(null);

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    axios.get(`${API}/equipamentos`, { headers }).then(r => setEquipamentos(r.data)).catch(() => {});
    axios.get(`${API}/linhas`, { headers }).then(r => setLinhas(r.data)).catch(() => {});
    axios.get(`${API}/clientes`, { headers }).then(r => setClientes(r.data)).catch(() => {});
    axios.get(`${API}/contratos/templates`, { headers }).then(r => setTemplates(r.data)).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const equipamentosDisponiveis = equipamentos.filter(e => e.status === 'estoque');
  const linhasDisponiveis = linhas.filter(l => !l.equipamento_id);
  const templatesDeCliente = templates.filter(t => !t.tipo || t.tipo === 'cliente');

  const etapas = equipPulado ? ETAPAS_BASE.filter(e => e.id !== 2) : ETAPAS_BASE;

  const inputStyle = { width: '100%', padding: '10px 12px', border: '1.5px solid #e0e0e0', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box', outline: 'none' };
  const labelStyle = { display: 'block', marginBottom: '4px', color: '#555', fontSize: '13px', fontWeight: '500' };
  const secaoStyle = { background: 'white', borderRadius: '14px', padding: '28px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' };
  const tituloSecao = { margin: '0 0 20px 0', color: '#333', fontSize: '18px' };
  const grid2 = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' };

  const etapaValida = () => {
    if (etapaAtual === 1) {
      if (equipPulado) return true;
      if (equipModo === 'existente') return !!equipExistenteId;
      return !!equipForm.serial && !!equipForm.modelo;
    }
    if (etapaAtual === 2) {
      if (linhaPulada) return true;
      if (linhaModo === 'existente') return !!linhaExistenteId;
      return !!linhaForm.simcard;
    }
    if (etapaAtual === 3) {
      if (clienteModo === 'existente') return !!clienteExistenteId;
      return !!clienteForm.nome_fantasia;
    }
    if (etapaAtual === 4) {
      return !!veiculoForm.identificador && !!veiculoForm.nome;
    }
    if (etapaAtual === 5) {
      if (!loginAtivo) return true;
      if (!loginForm.nome || !loginForm.email || !loginForm.senha) return false;
      return loginForm.senha === loginForm.confirmarSenha;
    }
    if (etapaAtual === 6) {
      if (!contratoAtivo) return true;
      return !!contratoForm.template_id && !!contratoForm.valor_mensal;
    }
    return true;
  };

  const irParaProxima = () => {
    if (!etapaValida()) { alert('Preencha os campos obrigatórios antes de continuar.'); return; }
    const idx = etapas.findIndex(e => e.id === etapaAtual);
    const proxima = etapas[idx + 1];
    if (proxima) setEtapaAtual(proxima.id);
  };

  const irParaAnterior = () => {
    const idx = etapas.findIndex(e => e.id === etapaAtual);
    const anterior = etapas[idx - 1];
    if (anterior) setEtapaAtual(anterior.id);
  };

  const fabricantesEquip = [...new Set(MODELOS_EQUIP.map(m => m.fabricante))].sort();

  const selecionarModeloEquip = (modelo) => {
    const m = MODELOS_EQUIP.find(m => m.modelo === modelo);
    if (m) setEquipForm(f => ({ ...f, modelo: m.modelo, fabricante: m.fabricante, protocolo: m.protocolo }));
    else setEquipForm(f => ({ ...f, modelo }));
  };

  const selecionarOperadora = (nome) => {
    const op = OPERADORAS.find(o => o.nome === nome);
    if (op) setLinhaForm(f => ({ ...f, operadora: op.nome, apn: op.apn, apn_usuario: op.usuario, apn_senha: op.senha }));
    else setLinhaForm(f => ({ ...f, operadora: nome }));
  };

  const reiniciar = () => {
    setEtapaAtual(1);
    setErro('');
    setEquipPulado(false);
    setEquipModo('novo');
    setEquipExistenteId('');
    setEquipForm({ serial: '', modelo: '', fabricante: '', protocolo: '', firmware: 'Original', observacoes: '' });
    setLinhaPulada(false);
    setLinhaModo('novo');
    setLinhaExistenteId('');
    setLinhaForm({ simcard: '', numero: '', operadora: '', apn: '', apn_usuario: '', apn_senha: '' });
    setClienteModo('novo');
    setClienteExistenteId('');
    setClienteForm({ nome_fantasia: '', razao_social: '', documento: '', email: '', celular: '', endereco: '', numero: '', bairro: '', cidade: '', estado: '', cep: '', plano: 'com_bloqueio' });
    setVeiculoForm({ identificador: '', nome: '', modelo: '', tipo: 'Veículo de Passeio', icone: '🚗', cor: '#1D9E75', observacoes: '' });
    setLoginAtivo(false);
    setLoginForm({ nome: '', email: '', senha: '', confirmarSenha: '', fuso_horario: 'America/Sao_Paulo' });
    setContratoAtivo(false);
    setContratoForm({ template_id: '', valor_mensal: '', dia_vencimento: '10', prazo_meses: '12', data_inicio: new Date().toISOString().split('T')[0], valor_por_rastreador: '', renovacao_automatica: true, observacao: '' });
    setContratoResultado(null);
    setCriado({ equipamentoId: null, linhaId: null, clienteId: null, targetId: null, loginId: null, contratoEnviado: false });
    setResultado(null);
    axios.get(`${API}/equipamentos`, { headers }).then(r => setEquipamentos(r.data)).catch(() => {});
    axios.get(`${API}/linhas`, { headers }).then(r => setLinhas(r.data)).catch(() => {});
    axios.get(`${API}/clientes`, { headers }).then(r => setClientes(r.data)).catch(() => {});
    axios.get(`${API}/contratos/templates`, { headers }).then(r => setTemplates(r.data)).catch(() => {});
  };

  const confirmarCadastro = async () => {
    setSalvando(true);
    setErro('');
    try {
      let equipamentoId = criado.equipamentoId;
      if (!equipPulado && !equipamentoId) {
        if (equipModo === 'existente') {
          equipamentoId = equipExistenteId;
        } else {
          const r = await axios.post(`${API}/equipamentos`, { ...equipForm, status: 'estoque' }, { headers });
          equipamentoId = r.data.id;
        }
        setCriado(c => ({ ...c, equipamentoId }));
      }

      let linhaId = criado.linhaId;
      if (!equipPulado && !linhaPulada && !linhaId) {
        if (linhaModo === 'existente') {
          const linhaEscolhida = linhas.find(l => String(l.id) === String(linhaExistenteId));
          await axios.put(`${API}/linhas/${linhaExistenteId}`, { ...linhaEscolhida, equipamento_id: equipamentoId }, { headers });
          linhaId = linhaExistenteId;
        } else {
          const r = await axios.post(`${API}/linhas`, { ...linhaForm, equipamento_id: equipamentoId, status: 'ativa' }, { headers });
          linhaId = r.data.id;
        }
        setCriado(c => ({ ...c, linhaId }));
      }

      let clienteId = criado.clienteId;
      if (!clienteId) {
        if (clienteModo === 'existente') {
          clienteId = clienteExistenteId;
        } else {
          const r = await axios.post(`${API}/clientes`, { ...clienteForm, status: 'ativo' }, { headers });
          clienteId = r.data.id;
        }
        setCriado(c => ({ ...c, clienteId }));
      }

      let targetId = criado.targetId;
      if (!targetId) {
        const r = await axios.post(`${API}/targets`, {
          ...veiculoForm,
          cliente_id: clienteId,
          equipamento_id: equipPulado ? null : equipamentoId
        }, { headers });
        targetId = r.data.id;
        setCriado(c => ({ ...c, targetId }));
        setResultado(r.data);
      }

      if (loginAtivo && !criado.loginId) {
        const rLogin = await axios.post(`${API}/logins`, {
          nome: loginForm.nome,
          email: loginForm.email,
          senha: loginForm.senha,
          perfil: 'cliente',
          cliente_id: clienteId,
          fuso_horario: loginForm.fuso_horario,
          targets: [targetId]
        }, { headers });
        setCriado(c => ({ ...c, loginId: rLogin.data.id }));
      }

      if (contratoAtivo && !criado.contratoEnviado) {
        const rContrato = await axios.post(`${API}/contratos/enviar`, {
          cliente_id: clienteId,
          tipo_destinatario: 'cliente',
          template_id: contratoForm.template_id,
          valor_mensal: contratoForm.valor_mensal,
          dia_vencimento: contratoForm.dia_vencimento,
          prazo_meses: contratoForm.prazo_meses,
          data_inicio: contratoForm.data_inicio,
          valor_por_rastreador: contratoForm.valor_por_rastreador,
          renovacao_automatica: contratoForm.renovacao_automatica,
          observacao: contratoForm.observacao
        }, { headers });
        setCriado(c => ({ ...c, contratoEnviado: true }));
        setContratoResultado(rContrato.data);
      }
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao cadastrar. Verifique os dados e tente novamente — o que já foi salvo não será duplicado.');
    }
    setSalvando(false);
  };

  const equipamentoEscolhido = equipModo === 'existente' ? equipamentos.find(e => String(e.id) === String(equipExistenteId)) : null;
  const linhaEscolhida = linhaModo === 'existente' ? linhas.find(l => String(l.id) === String(linhaExistenteId)) : null;
  const clienteEscolhido = clienteModo === 'existente' ? clientes.find(c => String(c.id) === String(clienteExistenteId)) : null;

  return (
    <div style={{ background: '#f5f7fa', minHeight: '100vh' }}>
      <Sidebar aberta={sidebarAberta} setAberta={setSidebarAberta} />
      <div style={{ position: 'fixed', top: 0, left: 0, right: 0, height: '60px', background: '#1a1a2e', display: 'flex', alignItems: 'center', padding: '0 24px', zIndex: 100 }}>
        <button onClick={() => setSidebarAberta(!sidebarAberta)} style={{ background: 'none', border: 'none', color: 'white', fontSize: '22px', cursor: 'pointer', marginRight: '16px' }}>☰</button>
        <span style={{ color: 'white', fontWeight: '700', fontSize: '18px' }}>⚡ Cadastro Rápido</span>
      </div>

      <div style={{ marginTop: '60px', padding: '24px', maxWidth: '760px', margin: '60px auto 0' }}>

        {!resultado && (
          <div style={{ display: 'flex', gap: '8px', marginBottom: '20px', flexWrap: 'wrap' }}>
            {etapas.map((e, i) => (
              <div key={e.id} style={{
                flex: 1, textAlign: 'center', padding: '10px 6px', borderRadius: '10px',
                background: etapaAtual === e.id ? '#1D9E75' : '#fff',
                color: etapaAtual === e.id ? 'white' : '#999',
                fontSize: '13px', fontWeight: '600', boxShadow: '0 1px 6px rgba(0,0,0,0.08)'
              }}>
                <div style={{ fontSize: '18px' }}>{e.icone}</div>
                {e.label}
              </div>
            ))}
          </div>
        )}

        {erro && (
          <div style={{ background: '#FCEBEB', color: '#A32D2D', padding: '14px 18px', borderRadius: '10px', marginBottom: '16px', fontSize: '14px' }}>
            ⚠️ {erro}
          </div>
        )}

        {resultado ? (
          <div style={secaoStyle}>
            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
              <div style={{ fontSize: '48px' }}>🎉</div>
              <h2 style={{ margin: '8px 0 0', color: '#1D9E75' }}>Cadastro concluído!</h2>
              <div style={{ color: '#666', marginTop: '6px' }}>
                Veículo <strong>{resultado.identificador}</strong> ({resultado.nome}) cadastrado com sucesso.
              </div>
            </div>

            {contratoResultado && (
              <div style={{ background: '#f8f9fb', borderRadius: '10px', padding: '16px', marginBottom: '8px' }}>
                <strong>📄 Contrato enviado!</strong>
                <div style={{ fontSize: '13px', color: '#666', margin: '8px 0' }}>
                  O link de assinatura foi gerado e enviado por e-mail (se o cliente tiver e-mail cadastrado).
                </div>
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                  <button onClick={() => { navigator.clipboard.writeText(contratoResultado.link); alert('Link copiado!'); }} style={{ padding: '8px 16px', borderRadius: '8px', border: '1.5px solid #ddd', background: 'white', color: '#333', fontWeight: '600', cursor: 'pointer', fontSize: '13px' }}>
                    🔗 Copiar link do contrato
                  </button>
                  <a href={contratoResultado.whatsapp_link} target="_blank" rel="noreferrer" style={{ padding: '8px 16px', borderRadius: '8px', border: 'none', background: '#25D366', color: 'white', fontWeight: '600', textDecoration: 'none', fontSize: '13px' }}>
                    📲 Enviar por WhatsApp
                  </a>
                </div>
              </div>
            )}

            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', marginTop: '24px' }}>
              <button onClick={reiniciar} style={{ padding: '12px 24px', borderRadius: '10px', border: 'none', background: '#1D9E75', color: 'white', fontWeight: '600', cursor: 'pointer' }}>
                ➕ Cadastrar outro
              </button>
              <a href="/targets" style={{ padding: '12px 24px', borderRadius: '10px', border: '1.5px solid #ddd', background: 'white', color: '#333', fontWeight: '600', textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
                Ver em Veículos
              </a>
            </div>
          </div>
        ) : (
          <div style={secaoStyle}>

            {etapaAtual === 1 && (
              <div>
                <h3 style={tituloSecao}>📟 Equipamento GPS</h3>
                <label style={{ ...labelStyle, display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
                  <input type="checkbox" checked={equipPulado} onChange={e => setEquipPulado(e.target.checked)} />
                  Ainda não tenho o equipamento — cadastrar depois
                </label>

                {!equipPulado && (
                  <>
                    <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
                      <button onClick={() => setEquipModo('novo')} style={{ flex: 1, padding: '10px', borderRadius: '8px', cursor: 'pointer', border: equipModo === 'novo' ? '2px solid #1D9E75' : '1.5px solid #ddd', background: equipModo === 'novo' ? '#E1F5EE' : 'white', fontWeight: '600' }}>➕ Novo equipamento</button>
                      <button onClick={() => setEquipModo('existente')} style={{ flex: 1, padding: '10px', borderRadius: '8px', cursor: 'pointer', border: equipModo === 'existente' ? '2px solid #1D9E75' : '1.5px solid #ddd', background: equipModo === 'existente' ? '#E1F5EE' : 'white', fontWeight: '600' }}>📦 Usar existente</button>
                    </div>

                    {equipModo === 'existente' ? (
                      <div>
                        <label style={labelStyle}>Selecione um equipamento em estoque</label>
                        <select style={inputStyle} value={equipExistenteId} onChange={e => setEquipExistenteId(e.target.value)}>
                          <option value="">Selecione...</option>
                          {equipamentosDisponiveis.map(e => <option key={e.id} value={e.id}>{e.serial} — {e.modelo}</option>)}
                        </select>
                        {equipamentosDisponiveis.length === 0 && <div style={{ fontSize: '12px', color: '#999', marginTop: '6px' }}>Nenhum equipamento em estoque disponível.</div>}
                      </div>
                    ) : (
                      <div style={grid2}>
                        <div>
                          <label style={labelStyle}>Serial / IMEI *</label>
                          <input style={inputStyle} value={equipForm.serial} onChange={e => setEquipForm({ ...equipForm, serial: e.target.value })} placeholder="Ex: 869731057522617" />
                        </div>
                        <div style={{ gridColumn: '1/-1' }}>
                          <label style={labelStyle}>Modelo * (fabricante e protocolo preenchidos automaticamente)</label>
                          <select style={inputStyle} value={equipForm.modelo} onChange={e => selecionarModeloEquip(e.target.value)}>
                            <option value="">Selecione o modelo</option>
                            {fabricantesEquip.map(fab => (
                              <optgroup key={fab} label={fab}>
                                {MODELOS_EQUIP.filter(m => m.fabricante === fab).map(m => (
                                  <option key={m.modelo} value={m.modelo}>{m.modelo}</option>
                                ))}
                              </optgroup>
                            ))}
                          </select>
                        </div>
                        <div>
                          <label style={labelStyle}>Fabricante</label>
                          <input style={{ ...inputStyle, background: '#f9f9f9' }} value={equipForm.fabricante} readOnly />
                        </div>
                        <div>
                          <label style={labelStyle}>Protocolo</label>
                          <input style={{ ...inputStyle, background: '#f9f9f9' }} value={equipForm.protocolo} readOnly />
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            )}

            {etapaAtual === 2 && !equipPulado && (
              <div>
                <h3 style={tituloSecao}>📡 Chip GPRS</h3>
                <label style={{ ...labelStyle, display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
                  <input type="checkbox" checked={linhaPulada} onChange={e => setLinhaPulada(e.target.checked)} />
                  Ainda não tenho o chip — cadastrar depois
                </label>

                {!linhaPulada && (
                  <>
                    <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
                      <button onClick={() => setLinhaModo('novo')} style={{ flex: 1, padding: '10px', borderRadius: '8px', cursor: 'pointer', border: linhaModo === 'novo' ? '2px solid #1D9E75' : '1.5px solid #ddd', background: linhaModo === 'novo' ? '#E1F5EE' : 'white', fontWeight: '600' }}>➕ Novo chip</button>
                      <button onClick={() => setLinhaModo('existente')} style={{ flex: 1, padding: '10px', borderRadius: '8px', cursor: 'pointer', border: linhaModo === 'existente' ? '2px solid #1D9E75' : '1.5px solid #ddd', background: linhaModo === 'existente' ? '#E1F5EE' : 'white', fontWeight: '600' }}>📦 Usar existente</button>
                    </div>

                    {linhaModo === 'existente' ? (
                      <div>
                        <label style={labelStyle}>Selecione um chip disponível (sem equipamento vinculado)</label>
                        <select style={inputStyle} value={linhaExistenteId} onChange={e => setLinhaExistenteId(e.target.value)}>
                          <option value="">Selecione...</option>
                          {linhasDisponiveis.map(l => <option key={l.id} value={l.id}>{l.simcard} — {l.numero || 'sem número'}</option>)}
                        </select>
                        {linhasDisponiveis.length === 0 && <div style={{ fontSize: '12px', color: '#999', marginTop: '6px' }}>Nenhum chip disponível.</div>}
                      </div>
                    ) : (
                      <div style={grid2}>
                        <div>
                          <label style={labelStyle}>SIM Card *</label>
                          <input style={inputStyle} value={linhaForm.simcard} onChange={e => setLinhaForm({ ...linhaForm, simcard: e.target.value })} placeholder="ICCID" />
                        </div>
                        <div>
                          <label style={labelStyle}>Número</label>
                          <input style={inputStyle} value={linhaForm.numero} onChange={e => setLinhaForm({ ...linhaForm, numero: e.target.value })} placeholder="(43) 99999-9999" />
                        </div>
                        <div style={{ gridColumn: '1/-1' }}>
                          <label style={labelStyle}>Operadora (APN, usuário e senha preenchidos automaticamente)</label>
                          <select style={inputStyle} value={linhaForm.operadora} onChange={e => selecionarOperadora(e.target.value)}>
                            <option value="">Selecione a operadora</option>
                            {OPERADORAS.map(o => <option key={o.nome} value={o.nome}>{o.nome}</option>)}
                          </select>
                        </div>
                        <div>
                          <label style={labelStyle}>APN</label>
                          <input style={{ ...inputStyle, background: '#f9f9f9' }} value={linhaForm.apn} readOnly />
                        </div>
                        <div>
                          <label style={labelStyle}>Usuário APN</label>
                          <input style={{ ...inputStyle, background: '#f9f9f9' }} value={linhaForm.apn_usuario} readOnly />
                        </div>
                        <div>
                          <label style={labelStyle}>Senha APN</label>
                          <input style={{ ...inputStyle, background: '#f9f9f9' }} value={linhaForm.apn_senha} readOnly />
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            )}

            {etapaAtual === 3 && (
              <div>
                <h3 style={tituloSecao}>👥 Cliente</h3>
                <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
                  <button onClick={() => setClienteModo('novo')} style={{ flex: 1, padding: '10px', borderRadius: '8px', cursor: 'pointer', border: clienteModo === 'novo' ? '2px solid #1D9E75' : '1.5px solid #ddd', background: clienteModo === 'novo' ? '#E1F5EE' : 'white', fontWeight: '600' }}>➕ Novo cliente</button>
                  <button onClick={() => setClienteModo('existente')} style={{ flex: 1, padding: '10px', borderRadius: '8px', cursor: 'pointer', border: clienteModo === 'existente' ? '2px solid #1D9E75' : '1.5px solid #ddd', background: clienteModo === 'existente' ? '#E1F5EE' : 'white', fontWeight: '600' }}>📦 Usar existente</button>
                </div>

                {clienteModo === 'existente' ? (
                  <div>
                    <label style={labelStyle}>Selecione um cliente</label>
                    <select style={inputStyle} value={clienteExistenteId} onChange={e => setClienteExistenteId(e.target.value)}>
                      <option value="">Selecione...</option>
                      {clientes.map(c => <option key={c.id} value={c.id}>{c.nome_fantasia}{c.documento ? ' — ' + c.documento : ''}</option>)}
                    </select>
                  </div>
                ) : (
                  <div style={grid2}>
                    <div>
                      <label style={labelStyle}>Nome Fantasia *</label>
                      <input style={inputStyle} value={clienteForm.nome_fantasia} onChange={e => setClienteForm({ ...clienteForm, nome_fantasia: e.target.value })} />
                    </div>
                    <div>
                      <label style={labelStyle}>Razão Social</label>
                      <input style={inputStyle} value={clienteForm.razao_social} onChange={e => setClienteForm({ ...clienteForm, razao_social: e.target.value })} />
                    </div>
                    <div>
                      <label style={labelStyle}>CPF/CNPJ</label>
                      <input style={inputStyle} value={clienteForm.documento} onChange={e => setClienteForm({ ...clienteForm, documento: e.target.value })} />
                    </div>
                    <div>
                      <label style={labelStyle}>E-mail</label>
                      <input style={inputStyle} value={clienteForm.email} onChange={e => setClienteForm({ ...clienteForm, email: e.target.value })} />
                    </div>
                    <div>
                      <label style={labelStyle}>Celular</label>
                      <input style={inputStyle} value={clienteForm.celular} onChange={e => setClienteForm({ ...clienteForm, celular: e.target.value })} placeholder="(43) 99999-9999" />
                    </div>
                    <div>
                      <label style={labelStyle}>Cidade</label>
                      <input style={inputStyle} value={clienteForm.cidade} onChange={e => setClienteForm({ ...clienteForm, cidade: e.target.value })} />
                    </div>
                    <div style={{ gridColumn: '1/-1' }}>
                      <label style={labelStyle}>Plano</label>
                      <select style={inputStyle} value={clienteForm.plano} onChange={e => setClienteForm({ ...clienteForm, plano: e.target.value })}>
                        <option value="com_bloqueio">🔒 Com bloqueio remoto</option>
                        <option value="sem_bloqueio">🔓 Sem bloqueio remoto</option>
                      </select>
                    </div>
                  </div>
                )}
              </div>
            )}

            {etapaAtual === 4 && (
              <div>
                <h3 style={tituloSecao}>🚗 Veículo</h3>
                <div style={grid2}>
                  <div>
                    <label style={labelStyle}>Placa / Identificador *</label>
                    <input style={inputStyle} value={veiculoForm.identificador} onChange={e => setVeiculoForm({ ...veiculoForm, identificador: e.target.value.toUpperCase() })} placeholder="ABC-1234" />
                  </div>
                  <div>
                    <label style={labelStyle}>Nome do Veículo *</label>
                    <input style={inputStyle} value={veiculoForm.nome} onChange={e => setVeiculoForm({ ...veiculoForm, nome: e.target.value })} placeholder="Ex: Corolla Branco 2022" />
                  </div>
                  <div>
                    <label style={labelStyle}>Modelo</label>
                    <input style={inputStyle} value={veiculoForm.modelo} onChange={e => setVeiculoForm({ ...veiculoForm, modelo: e.target.value })} />
                  </div>
                  <div>
                    <label style={labelStyle}>Tipo</label>
                    <select style={inputStyle} value={veiculoForm.tipo} onChange={e => setVeiculoForm({ ...veiculoForm, tipo: e.target.value })}>
                      {TIPOS_VEICULO.map(t => <option key={t} value={t}>{t}</option>)}
                    </select>
                  </div>
                  <div style={{ gridColumn: '1/-1' }}>
                    <label style={labelStyle}>Ícone no mapa</label>
                    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                      {ICONES_VEICULO.map(ic => (
                        <button key={ic} onClick={() => setVeiculoForm({ ...veiculoForm, icone: ic })} style={{
                          fontSize: '22px', padding: '6px 10px', border: veiculoForm.icone === ic ? '2px solid #1D9E75' : '2px solid #eee',
                          borderRadius: '8px', background: veiculoForm.icone === ic ? '#E1F5EE' : 'white', cursor: 'pointer'
                        }}>{ic}</button>
                      ))}
                    </div>
                  </div>
                  <div style={{ gridColumn: '1/-1' }}>
                    <label style={labelStyle}>Cor do marcador (parado/desligado)</label>
                    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
                      {CORES_VEICULO.map(c => (
                        <button key={c} onClick={() => setVeiculoForm({ ...veiculoForm, cor: c })} style={{
                          width: '28px', height: '28px', borderRadius: '50%', background: c, cursor: 'pointer',
                          border: veiculoForm.cor === c ? '3px solid #333' : '2px solid #eee'
                        }} />
                      ))}
                      <input type="color" value={veiculoForm.cor} onChange={e => setVeiculoForm({ ...veiculoForm, cor: e.target.value })} style={{ width: '32px', height: '28px', padding: '2px', border: '2px solid #eee', borderRadius: '8px', cursor: 'pointer' }} />
                    </div>
                  </div>
                </div>
              </div>
            )}

            {etapaAtual === 5 && (
              <div>
                <h3 style={tituloSecao}>🔑 Login de acesso do cliente</h3>
                <label style={{ ...labelStyle, display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
                  <input type="checkbox" checked={loginAtivo} onChange={e => setLoginAtivo(e.target.checked)} />
                  Criar acesso de login para esse cliente agora (e-mail/senha pra acompanhar o veículo)
                </label>

                {loginAtivo && (
                  <div style={grid2}>
                    <div>
                      <label style={labelStyle}>Nome *</label>
                      <input style={inputStyle} value={loginForm.nome} onChange={e => setLoginForm({ ...loginForm, nome: e.target.value })} placeholder="Nome de quem vai acessar" />
                    </div>
                    <div>
                      <label style={labelStyle}>E-mail *</label>
                      <input style={inputStyle} type="email" value={loginForm.email} onChange={e => setLoginForm({ ...loginForm, email: e.target.value })} placeholder="email@exemplo.com" />
                    </div>
                    <div>
                      <label style={labelStyle}>Senha *</label>
                      <input style={inputStyle} type="password" autoComplete="new-password" value={loginForm.senha} onChange={e => setLoginForm({ ...loginForm, senha: e.target.value })} placeholder="Digite a senha" />
                    </div>
                    <div>
                      <label style={labelStyle}>Confirmar Senha *</label>
                      <input style={inputStyle} type="password" autoComplete="new-password" value={loginForm.confirmarSenha} onChange={e => setLoginForm({ ...loginForm, confirmarSenha: e.target.value })} placeholder="Confirmar senha" />
                    </div>
                    <div style={{ gridColumn: '1/-1', fontSize: '12px', color: '#999' }}>
                      Esse login será criado com perfil "cliente", já vinculado ao cliente e ao veículo cadastrados aqui. Dá pra adicionar outros veículos a ele depois, na aba Logins.
                    </div>
                  </div>
                )}
              </div>
            )}

            {etapaAtual === 6 && (
              <div>
                <h3 style={tituloSecao}>📄 Contrato</h3>
                <label style={{ ...labelStyle, display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
                  <input type="checkbox" checked={contratoAtivo} onChange={e => setContratoAtivo(e.target.checked)} />
                  Gerar e enviar contrato agora para esse cliente assinar
                </label>

                {contratoAtivo && (
                  <div>
                    {templatesDeCliente.length === 0 && (
                      <div style={{ fontSize: '12px', color: '#E67E22', marginBottom: '12px' }}>⚠️ Nenhum template cadastrado para clientes. Crie um na aba Contratos → Templates antes de continuar.</div>
                    )}
                    <div style={grid2}>
                      <div style={{ gridColumn: '1/-1' }}>
                        <label style={labelStyle}>Template *</label>
                        <select style={{ ...inputStyle, background: 'white' }} value={contratoForm.template_id} onChange={e => setContratoForm({ ...contratoForm, template_id: e.target.value })}>
                          <option value="">Selecione o template...</option>
                          {templatesDeCliente.map(t => <option key={t.id} value={t.id}>{t.nome}</option>)}
                        </select>
                      </div>
                      <div>
                        <label style={labelStyle}>Valor mensal (R$) *</label>
                        <input style={inputStyle} type="number" step="0.01" value={contratoForm.valor_mensal} onChange={e => setContratoForm({ ...contratoForm, valor_mensal: e.target.value })} placeholder="0,00" />
                      </div>
                      <div>
                        <label style={labelStyle}>Valor por rastreador (R$)</label>
                        <input style={inputStyle} type="number" step="0.01" value={contratoForm.valor_por_rastreador} onChange={e => setContratoForm({ ...contratoForm, valor_por_rastreador: e.target.value })} placeholder="0,00" />
                      </div>
                      <div>
                        <label style={labelStyle}>Dia do vencimento</label>
                        <input style={inputStyle} type="number" min="1" max="31" value={contratoForm.dia_vencimento} onChange={e => setContratoForm({ ...contratoForm, dia_vencimento: e.target.value })} />
                      </div>
                      <div>
                        <label style={labelStyle}>Prazo (meses)</label>
                        <input style={inputStyle} type="number" min="1" value={contratoForm.prazo_meses} onChange={e => setContratoForm({ ...contratoForm, prazo_meses: e.target.value })} />
                      </div>
                      <div>
                        <label style={labelStyle}>Data de início</label>
                        <input style={inputStyle} type="date" value={contratoForm.data_inicio} onChange={e => setContratoForm({ ...contratoForm, data_inicio: e.target.value })} />
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <label style={{ ...labelStyle, display: 'flex', alignItems: 'center', gap: '8px', marginTop: '18px' }}>
                          <input type="checkbox" checked={contratoForm.renovacao_automatica} onChange={e => setContratoForm({ ...contratoForm, renovacao_automatica: e.target.checked })} />
                          Renovação automática mensal
                        </label>
                      </div>
                      <div style={{ gridColumn: '1/-1' }}>
                        <label style={labelStyle}>Observações</label>
                        <textarea style={{ ...inputStyle, minHeight: '70px', resize: 'vertical' }} value={contratoForm.observacao} onChange={e => setContratoForm({ ...contratoForm, observacao: e.target.value })} placeholder="Observações adicionais para o contrato (opcional)" />
                      </div>
                    </div>
                    <div style={{ marginTop: '10px', fontSize: '12px', color: '#999' }}>
                      O contrato será gerado a partir do template e enviado por e-mail (se o cliente tiver e-mail cadastrado) e por link de WhatsApp.
                    </div>
                  </div>
                )}
              </div>
            )}

            {etapaAtual === 7 && (
              <div>
                <h3 style={tituloSecao}>✅ Resumo da conferência</h3>

                <div style={{ marginBottom: '16px', padding: '14px', background: '#f8f9fb', borderRadius: '10px' }}>
                  <strong>📟 Equipamento:</strong>{' '}
                  {equipPulado
                    ? 'Será cadastrado depois'
                    : equipModo === 'existente'
                      ? (equipamentoEscolhido ? `${equipamentoEscolhido.serial} — ${equipamentoEscolhido.modelo} (existente)` : '—')
                      : `${equipForm.serial} — ${equipForm.modelo} (novo)`}
                </div>

                <div style={{ marginBottom: '16px', padding: '14px', background: '#f8f9fb', borderRadius: '10px' }}>
                  <strong>📡 Chip:</strong>{' '}
                  {equipPulado || linhaPulada
                    ? 'Será cadastrado depois'
                    : linhaModo === 'existente'
                      ? (linhaEscolhida ? `${linhaEscolhida.simcard} (existente)` : '—')
                      : `${linhaForm.simcard} (novo)`}
                </div>

                <div style={{ marginBottom: '16px', padding: '14px', background: '#f8f9fb', borderRadius: '10px' }}>
                  <strong>👥 Cliente:</strong>{' '}
                  {clienteModo === 'existente'
                    ? (clienteEscolhido ? `${clienteEscolhido.nome_fantasia} (existente)` : '—')
                    : `${clienteForm.nome_fantasia} (novo)`}
                </div>

                <div style={{ marginBottom: '16px', padding: '14px', background: '#f8f9fb', borderRadius: '10px' }}>
                  <strong>🚗 Veículo:</strong> {veiculoForm.icone} {veiculoForm.identificador} — {veiculoForm.nome}
                </div>

                <div style={{ marginBottom: '16px', padding: '14px', background: '#f8f9fb', borderRadius: '10px' }}>
                  <strong>🔑 Login:</strong>{' '}
                  {loginAtivo ? `${loginForm.nome} — ${loginForm.email} (novo acesso)` : 'Não será criado agora'}
                </div>

                <div style={{ marginBottom: '8px', padding: '14px', background: '#f8f9fb', borderRadius: '10px' }}>
                  <strong>📄 Contrato:</strong>{' '}
                  {contratoAtivo
                    ? `${templatesDeCliente.find(t => String(t.id) === String(contratoForm.template_id))?.nome || 'template selecionado'} — R$ ${contratoForm.valor_mensal || '0,00'}/mês (será enviado)`
                    : 'Não será gerado agora'}
                </div>
              </div>
            )}

            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '28px' }}>
              <button onClick={irParaAnterior} disabled={etapaAtual === 1} style={{
                padding: '12px 22px', borderRadius: '10px', border: '1.5px solid #ddd', background: 'white',
                color: etapaAtual === 1 ? '#ccc' : '#333', fontWeight: '600', cursor: etapaAtual === 1 ? 'default' : 'pointer'
              }}>← Voltar</button>

              {etapaAtual === 7 ? (
                <button onClick={confirmarCadastro} disabled={salvando} style={{
                  padding: '12px 26px', borderRadius: '10px', border: 'none', background: '#1D9E75',
                  color: 'white', fontWeight: '700', cursor: salvando ? 'default' : 'pointer', opacity: salvando ? 0.7 : 1
                }}>{salvando ? 'Salvando...' : '✅ Confirmar e Cadastrar'}</button>
              ) : (
                <button onClick={irParaProxima} style={{
                  padding: '12px 26px', borderRadius: '10px', border: 'none', background: '#1D9E75',
                  color: 'white', fontWeight: '700', cursor: 'pointer'
                }}>Avançar →</button>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default CadastroRapido;
